module.exports = __webpack_public_path__ + "img/brother.c4abc8dc.png";